/*
 * @FilePath: /netHallOfficialAccounts/src/permission.js
 */
import qs from 'qs';
import router from '@/router';
import store from '@/store';
import wechatAuth from '@/plugins/vueWechatAuthPlugin';
import { Toast } from 'vant';
import serverconfig from '@/api/server.config';
console.log(serverconfig)
const WECHAT_APPID = serverconfig.WECHAT_APPID;
const WECHAT_AUTH_URL = serverconfig.WECHAT_AUTH_URL;
const BUILD_VERSION = process.env.VUE_APP_BUILD_VERSION;
// 设置APPID
wechatAuth.setAppId(WECHAT_APPID);

const whiteList = [
  '/404',
  '/NewsNotice/index',
  '/NewsList/NewsDetail',
];

async function checkUserBind(to, from, next) {
  next();
  // if (process.env.NODE_ENV !== 'development' && router.mode === 'hash') {
  // window.location.href =
  //     window.location.origin + window.location.pathname + window.location.hash;
  // } else {
  //   next();
  // }
}

router.beforeEach(async (to, from, next) => {
  // return next();
  // 在白名单，直接进入
  if (whiteList.indexOf(to.path) !== -1) {
    return next();
  }

  let ua = navigator.userAgent;
  // let isApp = ua.match(/EpointEJS/i);
  // let isZfb = ua.match(/alipay/i);
  let isWx = ua.match(/MicroMessenger/i);
  const { loginStatus } = store.getters;
  if (isWx) {
    console.log('微信浏览器');
    switch (Number(loginStatus)) {
      case 0:
        // 获取跳转地址
        wechatAuth.redirect_uri = processUrl();
        await store.dispatch('user/setLoginStatus', 1);
        window.location.href = wechatAuth.authUrl;

        break;
      case 1:
        try {
          wechatAuth.returnFromWechat(window.location.href);
          const code = wechatAuth.code;
          // 通过code换取token
          // await store.dispatch('user/loginWechatAuth', code); // 原始版本
          let arg = {
            wxCode: code,
            appId: WECHAT_APPID
          };
          await store.dispatch('user/loginWechatAuth', arg);
          await store.dispatch('user/setLoginStatus', 2);
          checkUserBind(to, from, next);
        } catch (err) {
          console.log('获取用户信息失败', err);
          await store.dispatch('user/setLoginStatus', 0);
          Toast.fail('获取用户信息失败!');
        }
        break;
      case 2:
        checkUserBind(to, from, next);
        break;
      default:
        break;
    }
  } else {
    console.log('app');
    console.log(loginStatus);
    console.log(store.getters);
    if (Number(loginStatus) === 2) {
      return next();
    } else {
      if (!to.path.includes('/login') || !store.getters.userInfo) {
        return next({ path: '/login' });
      } else {
        return next();
      }
    }
  }


});

/**
 * 处理url链接
 * @returns {string}
 */
function processUrl() {
  // 本地环境换通过auth.html拿code
  // if (process.env.NODE_ENV === 'development') {
  //   // 中间授权页地址
  //   return `${WECHAT_AUTH_URL}?backUrl=${window.location.href.split('?')[0]}`;
  // }
  const url = window.location.href;
  const hashIndex = url.indexOf('#');
  const baseUrl = hashIndex > -1 ? url.slice(0, hashIndex) : url;
  const hash = hashIndex > -1 ? url.slice(hashIndex) : '';
  const baseUrlParts = baseUrl.split('?');
  // 解决多次登录url添加重复的code与state问题
  const urlParams = qs.parse(baseUrlParts[1] || '');
  delete urlParams.code;
  delete urlParams.state;
  urlParams.v = BUILD_VERSION;
  const query = qs.stringify(urlParams);
  return `${baseUrlParts[0]}${query.length ? `?${query}` : ''}${hash}`;
}
